// extracted by mini-css-extract-plugin
export default {"orderActions":"oQhTJIwLq7s7rhLBPCoH","orderNumber":"lxFHWmk8E9x8bIkG8aUE"};